class videoWithProduct extends HTMLElement {
    constructor() {
        super();
        this.videoActionBtn()
        this.playVideoOnScreen()
    }

    videoActionBtn = () => {
        let videoTag = this.querySelector('video'),
            triggerBtn = this.querySelector('#videoAction');
            if (videoTag) {
                videoTag.addEventListener('click', () => {
                    if (!videoTag.paused) {
                        videoTag.pause();
                        triggerBtn.style.display = null
                    } else {
                        videoTag.play();
                        triggerBtn.style.display = "none";
                    }
                })
            }
    }
    playVideoOnScreen = () => {
        let videoTag = this.querySelector('video'),
            triggerBtn = this.querySelector('#videoAction');
            window.addEventListener('DOMContentLoaded', () => {
                videoTag.pause();
            })
        let videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    videoTag.play();
                    triggerBtn.style.display = "none";
                } else {
                    videoTag.pause();
                    triggerBtn.style.display = null
                }
            })
        })
        videoObserver.observe(videoTag)
    }
}

customElements.define('product-video-banner', videoWithProduct);